/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('MtProjectServiceApi', ($http, ApiErrorService) => {
    return {
        projectDataAll: projectDataAll,
        managedTesterDto: managedTesterDto,
        selectedItems: selectedItems,
        projectIterationButtons: projectIterationButtons,
        markProjectIterationAsCompleted: markProjectIterationAsCompleted
    };
    function projectDataAll(testerId) {
        return $http.get(`api/MtProject/ProjectDataAll?testerId=${testerId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function managedTesterDto(testerId, projectId, projectIterationId) {
        return $http.get(`api/MtProject/ManagedTesterDto?testerId=${testerId}&projectId=${projectId}&projectIterationId=${projectIterationId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function selectedItems(req) {
        return $http.post(`api/MtProject/SelectedItems`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function projectIterationButtons(testerId) {
        return $http.get(`api/MtProject/ProjectIterationButtons?testerId=${testerId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function markProjectIterationAsCompleted(projectIterationId) {
        return $http.post(`api/MtProject/MarkProjectIterationAsCompleted?projectIterationId=${projectIterationId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
